<script>
  // "Herança" direta, mantendo a estrutura isolada (arquivos)
  import TextareaField from '../desktop/textarea-field.vue'
  export default TextareaField
</script>
